// extracted by mini-css-extract-plugin
var _1 = "PageInput-moduleoutput__gLZnl";
export { _1 as "output" }
